import React from 'react'
import PropTypes from 'prop-types'

import Link from '../styles/Link'
import BodyText from '../styles/Text'
import ConfirmationTemplate from '../common/ConfirmationTemplate'
import pirTerminology from '../../util/pirTerminology'

const paidBodyText = [
  <>
    Your request has been created, and requests for digital signatures have been sent to the email addresses you provided.
    <b> Please ensure each digital signature is completed as early as possible.</b>
  </>,
  <>
    Once all signatures are received, your request will be entered into the queue. We aim to keep our service turnaround time of 1-3 business days
    after signatures are received. Please check your email for updates and your receipt for this transaction.
  </>
]

const submittedBodyText = [
  <>
    Your request has been created, and requests for digital signatures have been sent to the email addresses you provided.
    <b> Please ensure each digital signature is completed as early as possible.</b>
  </>,
  <>
    Once all signatures are received, your request will be entered into the queue. We aim to keep our service turnaround time of 1-3 business days
    after signatures are received. Please check your email for updates.
  </>
]

const PaymentConfirmation = ({ paid = true }) => (
  <ConfirmationTemplate title={paid ? 'Payment complete' : 'Request submitted'} bodyText={paid ? paidBodyText : submittedBodyText}>
    <BodyText>
      Need to make another {pirTerminology.getRequestName()}?&nbsp;
      <Link to="/pir/create">Get started</Link>
    </BodyText>
  </ConfirmationTemplate>
)

PaymentConfirmation.propTypes = {
  paid: PropTypes.bool
}

export default PaymentConfirmation
